import React, { useMemo } from 'react';

import { useRecoilValue } from 'recoil';

import { useExportContext } from 'lib/context/ExportContext/ExportContext';

import { currentPractice } from 'components/practice/practiceState';
import AGBasicTable from 'components/shared/AGBasicTable/AGBasicTable';

import { formatInvoiceProcedures } from '../lib/formatInvoiceProcedures';
import { CHILDREN_COLUMN_DEFS, PARENT_COLUMN_DEFS } from '../lib/previevColumnDefs';

const DEFAULT_COL_DEFS = {
  enableRowGroup: true,
  resizable: true,
  filter: false,
  suppressMenu: true,
  suppressMovable: true
};

const GRID_OPTIONS = {
  domLayout: 'autoHeight',
  animateRows: true,
  rowGroupPanelShow: 'always'
};

const NewInvoiceDetailsTable = ({ invoices, exportId, isView = false, isAEOB = true }) => {
  const practice = useRecoilValue(currentPractice);
  const claims = practice?.display_settings?.claims;
  const practiceTimezone = practice.timezone;

  const { setGridApi } = useExportContext();

  const detailCellRendererParams = useMemo(() => {
    return {
      detailGridOptions: {
        columnDefs: CHILDREN_COLUMN_DEFS(practiceTimezone, isAEOB, claims),
        defaultColDef: { flex: 1 },
        suppressHorizontalScroll: true,
        headerHeight: 0,
        onGridReady: (params) => {
          params.api.sizeColumnsToFit();
        }
      },
      getDetailRowData: (params) => {
        params.successCallback(params.data.children || []);
      }
    };
  }, [practiceTimezone, isAEOB, claims]);

  const rowData = useMemo(() => formatInvoiceProcedures({ invoices }), [invoices]);
  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  return (
    <div style={containerStyle} className="invoice-table-container">
      <AGBasicTable
        animateRows={true}
        defaultColDef={DEFAULT_COL_DEFS}
        columnDefs={PARENT_COLUMN_DEFS(practiceTimezone, isAEOB, claims)}
        rowData={rowData.map((row) => ({ ...row, hasStrike: row?.status === 'cancelled' }))} // with this we also add strikethrough in pdf export
        masterDetail={true}
        onGridReady={(params) => setGridApi(exportId, params.api)}
        groupDefaultExpanded={0}
        detailRowAutoHeight={true}
        detailCellRendererParams={detailCellRendererParams}
        suppressRowClickSelection={true}
        customClassName="ag-grid-interactive"
        gridOptions={{
          ...GRID_OPTIONS,
          rowGroupPanelShow: !isView,
          isRowMaster: (dataItem) => dataItem.children && dataItem.children.length > 0,
          rowClassRules: {
            'cancelled-row': (params) => params.data?.hasStrike
          }
        }}
      />
    </div>
  );
};

export default NewInvoiceDetailsTable;
